import React, { Component } from "react";
import { Button, message, Modal, Tooltip } from "antd";
import { connect } from "dva";
import ListPage from "../../../../../../components/ListPage";
import AddNormModal from "../AddNormModal";

const { confirm } = Modal;
const { ListTable } = ListPage;

@connect(({ norm, tree }) => ({
  selectedRowKeys: norm.selectedRowKeys,
  dataSource: tree.indexNormTreeList,
  spinProps: tree.spinProps,
  pageInfo: tree.pageInfo
}))
class NormTable extends Component {
  constructor(props) {
    super(props);
    const columns = [
      {
        title: "指标名称",
        dataIndex: "name",
        render: templateName => (
          <Tooltip placement="top" title={templateName}>
            <span>
              {templateName?.length <= 20
                ? templateName
                : `${templateName?.substring(0, 20)}...`}
            </span>
          </Tooltip>
        )
      },
      {
        title: "指标编号",
        dataIndex: "number"
      },
      {
        title: "指标分数",
        dataIndex: "score"
      }
    ];
    this.state = {
      columns,
      isShowAddModal: false,
      deletedCods: [],
      addNormformData: {
        type: 1,
        name: ""
      }
    };
  }

  componentDidMount() {
    this.handleFetchList();
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch({
      type: "tree/resetPageInfo"
    });
  }

  handleAddNorm = () => {
    this.setState({
      isShowAddModal: true
    });
  };

  handleAddNormOk = ({ type, name, number }) => {
    const { dispatch, record } = this.props;
    const { code, templateId, respondentOrgId } = record;
    const parentCode = "";
    // console.log("TCL: NormView -> handleAddNormOk -> name", name);
    // console.log("TCL: NormView -> handleAddNormOk -> type", type);
    dispatch({
      type: "tree/addNormOrGroup",
      payload: {
        parentCode,
        numberName: number,
        nodeName: name,
        nodeType: type,
        templateId,
        respondentOrgId: respondentOrgId || ""
      },
      callback: this.handleFetchList
    });
    this.setState({
      isShowAddModal: false
    });
  };

  // 分页改变
  handlePaginationChange = (page, pageSize) => {
    const params = { page, pageSize };
    this.handleFetchList(params);
  };

  // 调获取列表接口,及指标树
  handleFetchList = pageInfo => {
    const { record, dispatch } = this.props;
    const { templateId, respondentOrgId } = record;
    dispatch({
      type: "tree/getIndexNormList",
      payload: {
        templateId,
        respondentOrgId: respondentOrgId || "",
        page: 1,
        pageSize: 10,
        ...pageInfo
      }
    });

    dispatch({
      type: "tree/getNormTree",
      payload: {
        templateId,
        respondentOrgId: respondentOrgId || ""
      }
    });
  };

  deleteNorm = () => {
    const { selectedRowKeys, dispatch, record } = this.props;
    const { deletedCods } = this.state;
    const { templateId, respondentOrgId } = record;
    if (!selectedRowKeys || selectedRowKeys.length === 0) {
      message.error("请至少选中一个指标");
      return false;
    }
    confirm({
      title: `批量删除指标`,
      content: "确定删除选中的指标吗？",
      okText: "确定",
      cancelText: "取消",
      onOk: () => {
        dispatch({
          type: "tree/deleteNorm",
          payload: {
            indexCodes: deletedCods,
            templateId,
            respondentOrgId: respondentOrgId || ""
          },
          callback: this.handleFetchList
        });
      }
    });
    // 删除接口
    return false;
  };

  handleChangeSelected = (selectedRowKeys, selectedRows) => {
    const { dispatch } = this.props;
    const { deletedCods } = this.state;
    selectedRows.forEach(item => {
      deletedCods.push(item.code);
    });
    // console.log("TCL: NormTable -> handleChangeSelected -> selectedRows", selectedRows)
    // console.log("TCL: NormTable -> handleChangeSelected -> selectedRowKeys", selectedRowKeys)
    // 把选中的 selectedRowKeys 放入 store 中
    dispatch({
      type: "norm/save",
      payload: {
        selectedRowKeys
      }
    });
  };

  render() {
    const { columns, isShowAddModal, addNormformData } = this.state;
    const { selectedRowKeys, dataSource, spinProps, pageInfo } = this.props;

    const addNormProps = {
      title: "新增下级指标",
      visible: isShowAddModal,
      onCancel: () => this.setState({ isShowAddModal: false }),
      onOk: this.handleAddNormOk,
      data: addNormformData
    };

    const pageProps = {
      spinProps
    };

    const tableProps = {
      columns,
      rowKey: "id",
      list: dataSource,
      rowSelection: {
        selectedRowKeys,
        onChange: this.handleChangeSelected
      },
      pageInfo,
      onPageChange: this.handlePaginationChange
    };

    return (
      <ListPage {...pageProps}>
        <div className="tableHeader">
          <Button onClick={this.handleAddNorm} type="primary">
            + 新增下级指标
          </Button>
          <Button onClick={this.deleteNorm}>批量删除指标</Button>
        </div>
        <ListTable {...tableProps} />
        {isShowAddModal && <AddNormModal {...addNormProps} />}
      </ListPage>
    );
  }
}

export default NormTable;
